"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fuzzyTableFilter = void 0;
var match_sorter_1 = require("match-sorter");
function fuzzyTableFilter(rows, columnIds, filterValue) {
    if (!filterValue || !filterValue.length) {
        return rows;
    }
    var terms = filterValue.split(' ');
    if (!terms) {
        return rows;
    }
    // reduceRight will mean sorting is done by score for the _first_ entered word.
    // this allow us filtering values from multiple columns in order to provide a better UX
    return terms.reduceRight(function (results, term) {
        return (0, match_sorter_1.matchSorter)(results, term, {
            keys: columnIds.map(function (id) {
                return function (row) {
                    return row.values[id];
                };
            }),
        });
    }, rows);
}
exports.fuzzyTableFilter = fuzzyTableFilter;
// Let the table remove the filter if the string is empty
fuzzyTableFilter.autoRemove = function (val) { return !val; };
